import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, gravelfint, ravenBlack, white} from '/theme/color/on.color';
import {codGray, pine} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  modal: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: gravelfint,
  },
  content: {
    flex: 1,
    backgroundColor: white,
    borderRadius: 16,
    marginHorizontal: 16,
    padding: 24,
    gap: 22,
  },
  buttonsContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-end',
    paddingVertical: indent / 2,
    marginTop: indent / 2,
  },
  header: {
    fontSize: 16,
    color: ravenBlack,
    textAlign: 'center',
  },
  text: {
    color: codGray,
    fontSize: 16,
    textAlign: 'center',
  },
  useBiometricsButton: {
    alignItems: 'center',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: pine,
    backgroundColor: pine,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  blueButtonText: {
    color: white,
  },
  notNowButton: {
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  buttonText: {
    color: denim,
    marginTop: indent / 2,
  },
});
